// extracted by mini-css-extract-plugin
export var cell = "_62-4";
export var headerCell = "_62-2";
export var rowHeader = "_62-3";
export var table = "_62-1";
export var tableContainer = "_62-0";